import { createContext, useContext } from 'react';
import noop, { NoOp } from 'utils/noop';
import { MovableInkIntegration } from '../types';

export type IntegrationsState = {
  addIntegration: (code: string, name: string, login: string) => void;
  deleteIntegration: (id: number) => void;
  integrations: MovableInkIntegration[];
  isAdding: boolean;
  isDeleting: boolean;
  isFetchingIntegrations: boolean;
  refetchIntegrations: NoOp;
};

export const IntegrationsContext = createContext<IntegrationsState>({
  addIntegration: noop,
  deleteIntegration: noop,
  integrations: [],
  isAdding: false,
  isDeleting: false,
  isFetchingIntegrations: false,
  refetchIntegrations: noop,
});

export const useIntegrationContext = () => useContext(IntegrationsContext);
